import { shallowEqual } from 'react-redux';
import { useAppSelector } from 'store/hooks';
/**
  @deprecated use createSelector for memoisation of selector functions
*/
export const useReSelector = (selector, equalityFn) => useAppSelector(selector, equalityFn ?? shallowEqual);
export default { useReSelector };
